import {GetCoinsHistoryResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {useTrackContentView} from '@aboutyou/tracking';
import {COLORS, InView} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useEffect} from 'react';
import {EmptySection} from './EmptySection';
import {Transaction} from './Transaction';

export const CoinsHistoryPageView = (
  props: GetCoinsHistoryResponse & {
    onInView: VoidFunction;
  },
) => {
  const {sections, onInView} = props;
  const {t} = useTranslation();
  const trackContentView = useTrackContentView();

  useEffect(() => {
    trackContentView({
      pageTitle: 'coins_history',
      overridePageProps: {type: 'coins_history'},
    });
  }, []);

  const handleInView = (inView: boolean) => {
    if (inView) {
      onInView();
    }
  };

  return (
    <Wrapper data-testid="coinsHistoryTransactionSection">
      {sections.map((section, index) => {
        switch (section.type?.$case) {
          case 'transaction':
            return (
              <StyledTransaction
                key={index}
                transaction={section.type.transaction}
              />
            );
          default:
            return (
              <EmptySection key={index} title={t('No activites so far')} />
            );
        }
      })}
      <InView
        onChange={handleInView}
        triggerOnce
        rootMargin="800px"
        threshold={0}
        data-testid="loadMoreTrigger"
      >
        <LoadMoreTrigger />
      </InView>
    </Wrapper>
  );
};

const LoadMoreTrigger = styled.div`
  width: 100%;
`;

const StyledTransaction = styled(Transaction)`
  &::after {
    display: block;
    content: '';
    width: 100%;
    height: 1px;
    background: ${COLORS.Grey3};
    margin: 1rem 0;
  }
`;

const Wrapper = styled.div`
  ${StyledTransaction} {
    &:last-child {
      &::after {
        display: none;
      }
    }
  }
`;
